module.exports = __webpack_public_path__ + "static/img/bannerNoWords@2x.24daca3d.png";